<app-base-page pageTitle="{{entityType?.name}} Rules"
	[pageContext]="pageContext"
	[loading]="loadingTableDefinitions"
	pageContextOperationGroupName="AdminEntity.PageContext"
	utilityMenuOperationGroupName="">

	<div *ngIf="loadingTableDefinitions"
		class="text-center ui-g-12">
		<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size">
		</span>
	</div>

	<div *ngIf="!loadingTableDefinitions"
		class="ui-g-12">
		<app-common-table
			[tableDefinitions]="tableDefinitions">
		</app-common-table>
	</div>
</app-base-page>